import styled from 'styled-components';
import { ViewIds } from '@ardoq/api-types';
import { connect } from '@ardoq/rxbeach';
import { toViewpointModeMainViewInstanceId } from 'appLayout/mainViewInstanceIds';
import { getViewpointModeViewSettingsWithChanges$ } from 'views/environmentals/viewSettings/viewpointModeViewSettings$';
import { SpiderView } from './SpiderView';
import { spiderViewModel$ } from './spiderViewModel$';

const VIEW_ID = ViewIds.SPIDER_2;
const VIEW_INSTANCE_ID = toViewpointModeMainViewInstanceId(VIEW_ID);

const ViewRoot = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
`;

const ConnectedSpiderView = connect(
  SpiderView,
  spiderViewModel$(
    VIEW_INSTANCE_ID,
    getViewpointModeViewSettingsWithChanges$(VIEW_ID, VIEW_INSTANCE_ID)
  )
);

export const SpiderViewController = () => (
  <ViewRoot className="prevent-context-change">
    <ConnectedSpiderView />
  </ViewRoot>
);
